import MockAdapter from 'axios-mock-adapter/types'

export function mockTrades(mocker: MockAdapter) {
  mocker.onGet('/market/trades').reply((config) => {
    return [
      200,
      {
        code: 200,
        msg: 'success',
        data: {
          spotsSymbols: [
            {
              id: 100103,
              name: 'WBTC_USDC',
              startTime: 1680278400000,
              endTime: 5995814400000,
              trade: 'SPOTS',
              baseName: 'WBTC',
              baseMinimumIncrement: 1.0e-5,
              baseScale: 5,
              baseMinimumQuantity: 1.0e-5,
              baseMaximumQuantity: 10000.0,
              quoteName: 'USDC',
              quoteMinimumIncrement: 0.01,
              quoteScale: 2,
              supportMarginTrade: true,
              alwaysChargeQuote: false,
              baseTokenId: 100,
              quoteTokenId: 103,
            },
            {
              id: 105103,
              name: 'WETH_USDC',
              startTime: 1680278400000,
              endTime: 5995814400000,
              trade: 'SPOTS',
              baseName: 'WETH',
              baseMinimumIncrement: 1.0e-4,
              baseScale: 4,
              baseMinimumQuantity: 1.0e-4,
              baseMaximumQuantity: 10000.0,
              quoteName: 'USDC',
              quoteMinimumIncrement: 0.01,
              quoteScale: 2,
              supportMarginTrade: false,
              alwaysChargeQuote: false,
              baseTokenId: 105,
              quoteTokenId: 103,
            },
            {
              id: 104103,
              name: 'WAVAX_USDC',
              startTime: 1680278400000,
              endTime: 5995814400000,
              trade: 'SPOTS',
              baseName: 'WAVAX',
              baseMinimumIncrement: 0.01,
              baseScale: 2,
              baseMinimumQuantity: 0.01,
              baseMaximumQuantity: 10000.0,
              quoteName: 'USDC',
              quoteMinimumIncrement: 0.01,
              quoteScale: 2,
              supportMarginTrade: false,
              alwaysChargeQuote: false,
              baseTokenId: 104,
              quoteTokenId: 103,
            },
          ],
          contractsCurrencies: ['USDC'],
          contractsSymbols: [
            {
              id: 132,
              name: 'XWBTC',
              startTime: 1680278400000,
              endTime: 5995814400000,
              trade: 'CONTRACTS',
              type: 'PERPETUAL',
              baseCurrency: 'WBTC',
              marginCurrency: 'USDC',
              quoteCurrency: 'USDC',
              multiplier: 0.001,
              quoteMinimumIncrement: 0.01,
              quoteScale: 2,
              baseScale: 0,
              baseMinimumIncrement: 1,
              maximumQuantityPerOrder: 10000000,
              riskLimit: {
                id: 105,
                initialMarginRate: 0.01,
                maintenanceMarginRate: 0.005,
                marginRateStep: 0.005,
                maxLeverage: 100,
                riskLimitBase: 30000000,
                riskLimitStep: 10000,
                maxRiskLimitSteps: 0,
                createdAt: 1546956010600,
              },
              settlementFeeRate: 0.0,
              referencedIndexes: {
                SPOT: 10122,
                FAIR: 10125,
                PREMIUM_1M: 10126,
                PREMIUM_AGGREGATE: 10127,
                MAX_PREMIUM_RATE: 10124,
                FUNDING_RATE_1M: 10128,
                FUNDING_RATE_AGGREGATE: 10129,
                LENDING_RATE_1D: 10123,
              },
            },
            {
              id: 146,
              name: 'XWETH',
              startTime: 1680278400000,
              endTime: 5995814400000,
              trade: 'CONTRACTS',
              type: 'PERPETUAL',
              baseCurrency: 'WETH',
              marginCurrency: 'USDC',
              quoteCurrency: 'USDC',
              multiplier: 0.001,
              quoteMinimumIncrement: 0.01,
              quoteScale: 2,
              baseScale: 0,
              baseMinimumIncrement: 1,
              maximumQuantityPerOrder: 10000000,
              riskLimit: {
                id: 106,
                initialMarginRate: 0.01,
                maintenanceMarginRate: 0.005,
                marginRateStep: 0.005,
                maxLeverage: 100,
                riskLimitBase: 30000000,
                riskLimitStep: 10000,
                maxRiskLimitSteps: 0,
                createdAt: 1546956031080,
              },
              settlementFeeRate: 0.0,
              referencedIndexes: {
                SPOT: 10145,
                FAIR: 10148,
                PREMIUM_1M: 10149,
                PREMIUM_AGGREGATE: 10150,
                MAX_PREMIUM_RATE: 10147,
                FUNDING_RATE_1M: 10151,
                FUNDING_RATE_AGGREGATE: 10152,
                LENDING_RATE_1D: 10146,
              },
            },
          ],
          convertTokens: [
            {
              id: 100,
              name: 'WBTC',
              chainTokenId: 141,
              displayName: 'WBTC',
              displayOrder: 1,
              scale: 5,
              minTradeVolume: 1.0e-4,
              maxTradeVolume: 10000.0,
              iconUrl: 'https://static.zk.link/token/icons/default/btc.svg',
              createdAt: 1698722370265,
              updatedAt: 1698722370265,
            },
            {
              id: 103,
              name: 'USDC',
              chainTokenId: 17,
              displayName: 'USDC',
              displayOrder: 2,
              scale: 2,
              minTradeVolume: 0.01,
              maxTradeVolume: 10000.0,
              iconUrl: 'https://static.zk.link/token/icons/default/usdc.svg',
              createdAt: 1698722370265,
              updatedAt: 1698722370265,
            },
            {
              id: 105,
              name: 'WETH',
              chainTokenId: 142,
              displayName: 'WETH',
              displayOrder: 3,
              scale: 5,
              minTradeVolume: 0.01,
              maxTradeVolume: 10000.0,
              iconUrl: 'https://static.zk.link/token/icons/default/eth.svg',
              createdAt: 1698722370265,
              updatedAt: 1698722370265,
            },
          ],
          indexes: [
            {
              id: 10122,
              name: 'WBTC',
              startTime: 0,
              endTime: 5995814400000,
              scale: 2,
            },
            {
              id: 10123,
              name: 'WBTC_DAILYRATE',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10124,
              name: 'WBTC_MAXBTCUSDPI',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10125,
              name: 'WBTC_USD_FAIR',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10126,
              name: 'WBTC_USD_PI',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10127,
              name: 'WBTC_USD_PI8H',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10128,
              name: 'WBTC_FR',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10129,
              name: 'WBTC_FR8H',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10130,
              name: 'WBTC_INS1H',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10131,
              name: 'WBTC_INS1D',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10145,
              name: 'WETH',
              startTime: 0,
              endTime: 5995814400000,
              scale: 2,
            },
            {
              id: 10146,
              name: 'WETH_DAILYRATE',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10147,
              name: 'WETH_MAXWETHUSDPI',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10148,
              name: 'WETH_USD_FAIR',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10149,
              name: 'WETH_USD_PI',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10150,
              name: 'WETH_USD_PI8H',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10151,
              name: 'WETH_FR',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10152,
              name: 'WETH_FR8H',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10153,
              name: 'WETH_INS1H',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
            {
              id: 10154,
              name: 'WETH_INS1D',
              startTime: 0,
              endTime: 5995814400000,
              scale: 6,
            },
          ],
          spotsCurrencies: ['USDC', 'WAVAX', 'WETH', 'WBTC'],
          riskLimits: [
            {
              id: 105,
              initialMarginRate: 0.01,
              maintenanceMarginRate: 0.005,
              marginRateStep: 0.005,
              maxLeverage: 100,
              riskLimitBase: 30000000,
              riskLimitStep: 10000,
              maxRiskLimitSteps: 0,
              createdAt: 1546956010600,
            },
            {
              id: 106,
              initialMarginRate: 0.01,
              maintenanceMarginRate: 0.005,
              marginRateStep: 0.005,
              maxLeverage: 100,
              riskLimitBase: 30000000,
              riskLimitStep: 10000,
              maxRiskLimitSteps: 0,
              createdAt: 1546956031080,
            },
          ],
          chains: {
            '144': [
              {
                id: 10081,
                chainTokenId: 144,
                chainId: 5,
                address: '0x9a54671684392d160e5572c3553daed2e7d62051',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625695,
              },
              {
                id: 10082,
                chainTokenId: 144,
                chainId: 8,
                address: '0x0857fdf217e54954c0f4a77b62c04b246ef504cd',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625729,
              },
              {
                id: 10083,
                chainTokenId: 144,
                chainId: 17,
                address: '0xaf3a3fd0eea662dd1aefa8b04c201038a4ff5761',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625679,
              },
              {
                id: 10084,
                chainTokenId: 144,
                chainId: 7,
                address: '0xf72da9d5de97a29caed018569d4564b36a56d02e',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625723,
              },
              {
                id: 10085,
                chainTokenId: 144,
                chainId: 16,
                address:
                  '0x064b6b1b61080fa11b1c912bd83878a4d8d98359e874e2fe7f878c610a286325',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625669,
              },
              {
                id: 10086,
                chainTokenId: 144,
                chainId: 6,
                address: '0x4c58cbf4e9594898e2cc66fda3f435cd3622fe9f',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625715,
              },
              {
                id: 10087,
                chainTokenId: 144,
                chainId: 14,
                address: '0x53438eddeb3d3fd39c99150aca2575f73ce14198',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625738,
              },
              {
                id: 10102,
                chainTokenId: 144,
                chainId: 13,
                address: '0x4a3cac418c2cef97e5e1b34f691a1d0d83c0ef8c',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625702,
              },
              {
                id: 10103,
                chainTokenId: 144,
                chainId: 18,
                address: '0xe782288afc111f99af89385281a1cd4ecba93fad',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625659,
              },
            ],
            '17': [
              {
                id: 10066,
                chainTokenId: 17,
                chainId: 7,
                address: '0x3119fd5290e3b946a0398dc6571de0ff378da5fd',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625537,
              },
              {
                id: 10067,
                chainTokenId: 17,
                chainId: 8,
                address: '0x6afa29ff611c46e4661960b3797d6bd844969932',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625505,
              },
              {
                id: 10068,
                chainTokenId: 17,
                chainId: 6,
                address: '0x16c640b0db283a4129dccf087dbf249bd87be493',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625544,
              },
              {
                id: 10069,
                chainTokenId: 17,
                chainId: 17,
                address: '0x27cbbe82447a0c188ebd7bc5fd706d140c7b0642',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625484,
              },
              {
                id: 10070,
                chainTokenId: 17,
                chainId: 5,
                address: '0xe31e4629e8a909957caeb80ffc6d1523fbee8dd0',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625521,
              },
              {
                id: 10071,
                chainTokenId: 17,
                chainId: 4,
                address: '0x2593f2930feb95ef7461cabe3f1ca8f3dd3d0da8',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625512,
              },
              {
                id: 10072,
                chainTokenId: 17,
                chainId: 16,
                address:
                  '0x078894fa686672a3b3f8389dc49db3b3a6c14bb9e0bf3feaa7ee1e0e3a1e720f',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625532,
              },
              {
                id: 10073,
                chainTokenId: 17,
                chainId: 14,
                address: '0xc086f22fc93ec3d4a3e4a59f5f27668b7720d312',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625488,
              },
              {
                id: 10100,
                chainTokenId: 17,
                chainId: 13,
                address: '0x883fa0ab7415246ab6bd462f947e300e7c3746e3',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625495,
              },
              {
                id: 10101,
                chainTokenId: 17,
                chainId: 18,
                address: '0x0a434fbe887d74bf104ef3c3fe286034549f63f4',
                decimals: 6,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625553,
              },
            ],
            '36': [
              {
                id: 10075,
                chainTokenId: 36,
                chainId: 4,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625575,
              },
              {
                id: 10077,
                chainTokenId: 36,
                chainId: 16,
                address:
                  '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625611,
              },
              {
                id: 10078,
                chainTokenId: 36,
                chainId: 6,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625626,
              },
              {
                id: 10079,
                chainTokenId: 36,
                chainId: 8,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625565,
              },
              {
                id: 10080,
                chainTokenId: 36,
                chainId: 7,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625618,
              },
              {
                id: 10096,
                chainTokenId: 36,
                chainId: 13,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625598,
              },
              {
                id: 10097,
                chainTokenId: 36,
                chainId: 18,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625648,
              },
              {
                id: 10106,
                chainTokenId: 36,
                chainId: 14,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625639,
              },
              {
                id: 10107,
                chainTokenId: 36,
                chainId: 5,
                address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                decimals: 18,
                fastWithdraw: false,
                isSupport: true,
                updateTime: 1707114625585,
              },
            ],
            '141': [
              {
                id: 10059,
                chainTokenId: 141,
                chainId: 16,
                address:
                  '0x0595de9d1b6cd2768360477d0f435944ce045fb44d9e0e21d6f2efa73062ca23',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625420,
              },
              {
                id: 10060,
                chainTokenId: 141,
                chainId: 5,
                address: '0xb3a1ffcab3554642b8f207c19d07d949de4bf351',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625461,
              },
              {
                id: 10061,
                chainTokenId: 141,
                chainId: 6,
                address: '0xb81fe42de28e7452088b77f3eb9685487734e088',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625415,
              },
              {
                id: 10062,
                chainTokenId: 141,
                chainId: 17,
                address: '0x224e8f9802da8dc39c3982698613a0795d03f6d1',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625432,
              },
              {
                id: 10063,
                chainTokenId: 141,
                chainId: 7,
                address: '0xecdd9c9dcfe88e14a34369657532c5a387765ea8',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625453,
              },
              {
                id: 10064,
                chainTokenId: 141,
                chainId: 8,
                address: '0xc9639ca358a78d10497373a7a795b48e629a14a6',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625446,
              },
              {
                id: 10065,
                chainTokenId: 141,
                chainId: 14,
                address: '0x19067a15a5bbdd5ad8a4755b6a447a451badb658',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625440,
              },
              {
                id: 10098,
                chainTokenId: 141,
                chainId: 13,
                address: '0x03c90aaca9d4f7dfe35d1ee98d55e4eb9776e832',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625424,
              },
              {
                id: 10099,
                chainTokenId: 141,
                chainId: 18,
                address: '0xea6232604c847d14638a30c1d261af6c321aab05',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625475,
              },
            ],
            '142': [
              {
                id: 10088,
                chainTokenId: 142,
                chainId: 5,
                address: '0xad7fd7daa419547f51e8103bda875f28bdbaa7e5',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625749,
              },
              {
                id: 10089,
                chainTokenId: 142,
                chainId: 7,
                address: '0x457e705c8552f79ae70bec19df5cd46f05384fca',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625783,
              },
              {
                id: 10090,
                chainTokenId: 142,
                chainId: 4,
                address: '0xa07250fa05e585ee78f6abe77a0ba83835c8cedf',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625820,
              },
              {
                id: 10091,
                chainTokenId: 142,
                chainId: 6,
                address: '0x224e8f9802da8dc39c3982698613a0795d03f6d1',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625793,
              },
              {
                id: 10092,
                chainTokenId: 142,
                chainId: 16,
                address:
                  '0x06f7676496a7458456c9ea5e561f8f6a5f1341f6f1c66a05f358db70bdf06000',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625812,
              },
              {
                id: 10093,
                chainTokenId: 142,
                chainId: 8,
                address: '0x457e705c8552f79ae70bec19df5cd46f05384fca',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625760,
              },
              {
                id: 10094,
                chainTokenId: 142,
                chainId: 17,
                address: '0x4c58cbf4e9594898e2cc66fda3f435cd3622fe9f',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625776,
              },
              {
                id: 10095,
                chainTokenId: 142,
                chainId: 14,
                address: '0xaf8e815b3cdb154e978241f113673a94b3078c82',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625787,
              },
              {
                id: 10104,
                chainTokenId: 142,
                chainId: 13,
                address: '0xc24fca69f3d30cd2aae94e4829677ecac283d031',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625768,
              },
              {
                id: 10105,
                chainTokenId: 142,
                chainId: 18,
                address: '0xf804458f05986acdf1ced63e08a7047ec759b134',
                decimals: 18,
                fastWithdraw: true,
                isSupport: true,
                updateTime: 1707114625806,
              },
            ],
          },
          tokenMappingList: [
            {
              id: 1,
              tokenId: 100,
              tokenName: 'WBTC',
              mappingTokenName: 'wBTC',
              mappingTokenId: 141,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/btc.svg',
              tokenType: 0,
            },
            {
              id: 2,
              tokenId: 103,
              tokenName: 'USDC',
              mappingTokenName: 'USDC',
              mappingTokenId: 17,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/usdc.svg',
              tokenType: 0,
            },
            {
              id: 3,
              tokenId: 132,
              tokenName: 'XWBTC',
              mappingTokenName: 'XWBTC',
              mappingTokenId: 0,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/btc.svg',
              tokenType: 1,
            },
            {
              id: 4,
              tokenId: 101,
              tokenName: 'ETH',
              mappingTokenName: 'ETH',
              mappingTokenId: 36,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/eth.svg',
              tokenType: 0,
            },
            {
              id: 18,
              tokenId: 104,
              tokenName: 'WAVAX',
              mappingTokenName: 'wAVAX',
              mappingTokenId: 144,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/avax.svg',
              tokenType: 0,
            },
            {
              id: 19,
              tokenId: 105,
              tokenName: 'WETH',
              mappingTokenName: 'wETH',
              mappingTokenId: 142,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/eth.svg',
              tokenType: 0,
            },
            {
              id: 20,
              tokenId: 146,
              tokenName: 'XWETH',
              mappingTokenName: 'XWETH',
              mappingTokenId: 3,
              tokenIconUrl:
                'https://static.zk.link/token/icons/default/eth.svg',
              tokenType: 1,
            },
          ],
          currencies: [
            {
              id: 100,
              name: 'WBTC',
              main: false,
              conversionRatio: 1,
              createdAt: 0,
              displayName: 'Bitcoin',
            },
            {
              id: 101,
              name: 'ETH',
              main: false,
              conversionRatio: 0,
              createdAt: 0,
              displayName: 'Ethereum',
            },
            {
              id: 103,
              name: 'USDC',
              main: true,
              conversionRatio: 1,
              createdAt: 0,
              displayName: 'USDC Tether',
            },
            {
              id: 104,
              name: 'WAVAX',
              main: false,
              conversionRatio: 0,
              createdAt: 0,
              displayName: 'Avalanche',
            },
            {
              id: 105,
              name: 'WETH',
              main: false,
              conversionRatio: 0.9,
              createdAt: 0,
              displayName: 'Wrap Ethereum',
            },
          ],
        },
        success: true,
      },
    ]
  })
}
